import Header from "components/atomics/sections/Header";
import { useIntegrationContext } from "contexts/integrationContext";
import useNavigation from "hooks/useNavigation";
import { RIBON_COMPANY_ID } from "utils/constants";
import { logEvent } from "lib/events";
import { useTicketsContext } from "contexts/ticketsContext";
import Avatar from "assets/images/avatar.svg";
import TicketsCounter from "./TicketsCounter";
import SettingsMenu from "./SettingsMenu";
import * as S from "./styles";

export type Props = {
  rightComponent?: JSX.Element;
  hasBackButton?: boolean;
  hideMenu?: boolean;
  outline?: boolean;
  member?: boolean;
  hideTickets?: boolean;
};

function LayoutHeader({
  rightComponent,
  hasBackButton = false,
  hideMenu = false,
  outline = false,
  member = false,
  hideTickets = false,
}: Props): JSX.Element {
  const { currentIntegrationId: integrationId, integration } =
    useIntegrationContext();
  const { navigateBack, navigateTo } = useNavigation();

  const { hasTickets } = useTicketsContext();

  if (!integrationId) return <div />;

  function renderSideLogo() {
    if (integrationId?.toString() === RIBON_COMPANY_ID) return undefined;

    return integration?.logo || Avatar;
  }

  function handleSideLogoClick() {
    if (!integration?.integrationTask?.linkAddress) return;
    if (hasTickets) {
      navigateTo("return-to-integration");
      return;
    }

    logEvent("backIntegration_click", { from: "header" });
    window.open(integration.integrationTask.linkAddress);
  }

  const onSideLogoClick = integration?.integrationTask?.linkAddress
    ? handleSideLogoClick
    : undefined;

  return (
    <S.Container outline={outline} member={member}>
      <Header
        hasBackButton={hasBackButton}
        onBackButtonClick={navigateBack}
        sideLogo={renderSideLogo()}
        onSideLogoClick={onSideLogoClick}
        rightComponent={
          <S.ContainerRight>
            {rightComponent}
            {!hideMenu && (
              <S.ContainerButtons>
                {!hideTickets && (
                  <>
                    <TicketsCounter outline={outline} />
                    <S.Pipe />
                  </>
                )}
                <SettingsMenu outline={outline} />
              </S.ContainerButtons>
            )}
          </S.ContainerRight>
        }
      />
    </S.Container>
  );
}

export default LayoutHeader;
